module.exports = __webpack_public_path__ + "img/Info Page 2 left.3be62f14.png";